import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);
export const gbp = (n) => `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: Number(n) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
const SEP = "/";
export const TZ_OPTIONS = [["GMT", "GMT (UTC+0)"], ["Europe/London", "UK time (GMT/BST)"], ["Europe/Dublin", "Ireland (GMT/IST)"], ["Europe/Paris", "Central Europe (CET/CEST)"], ["Europe/Athens", "Eastern Europe (EET/EEST)"], ["Asia/Dubai", "Gulf (GST)"], ["America/New_York", "US Eastern"], ["Australia/Sydney", "Sydney"]];
export const getTz = () => localStorage.getItem("mhh_tz") || "GMT";
export const setTz = (tz) => localStorage.setItem("mhh_tz", tz || "GMT");
const parts = (d, tz, opts) => Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: tz, ...opts }).formatToParts(d).map((p) => [p.type, p.value]));
const isDay = (s) => typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s);
const toDate = (s) => new Date(isDay(s) ? `${s}T00:00:00Z` : s);
export const fmtDate = (s) => {
  if (!s) return "—";
  const p = parts(toDate(s), isDay(s) ? "UTC" : getTz(), { day: "2-digit", month: "2-digit", year: "numeric" });
  return `${p.day}${SEP}${p.month}${SEP}${p.year}`;
};
export const fmtDay = (s) => (s ? `${parts(toDate(s), isDay(s) ? "UTC" : getTz(), { weekday: "short" }).weekday} ${fmtDate(s)}` : "—");
const tzLabel = () => (getTz() === "GMT" ? "GMT" : parts(new Date(), getTz(), { timeZoneName: "short" }).timeZoneName);
export const fmtTime = (s) => { if (!s) return ""; const p = parts(new Date(s), getTz(), { hour: "2-digit", minute: "2-digit", hourCycle: "h23" }); return `${p.hour}:${p.minute} ${tzLabel()}`; };
export const fmtDateTime = (s) => (s ? `${fmtDate(s)}, ${fmtTime(s)}` : "—");
export const ago = (s) => {
  const m = Math.round((Date.now() - new Date(s)) / 60000);
  if (m < 60) return `${Math.max(m, 1)}m ago`;
  if (m < 1440) return `${Math.round(m / 60)}h ago`;
  return `${Math.round(m / 1440)}d ago`;
};
export const URGENCY = { emergency: "Emergency", asap: "ASAP", "24h": "Within 24 hours", week: "Within a week", month: "Within a month", flexible: "Flexible", date: "Specific date" };
export const dashFor = (u) => (u?.role === "admin" ? "/admin" : u?.role === "provider" ? "/provider" : "/dashboard");

export async function upload(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads", fd);
  return data;
}

export async function startCheckout(payload) {
  const { data } = await api.post("/payments/checkout", { ...payload, origin_url: window.location.origin });
  window.location.href = data.paid ? `/payment/success?session_id=${data.session_id}` : data.checkout_url;
}
